export const CANONICAL_IMPORT_FIELDS = [
  {
    key: 'firstName',
    label: 'First Name',
    category: 'Contact',
    identityRelevant: true,
    requiredForIdentity: false,
    allowMultipleSources: false,
    deferred: false,
    synonyms: ['first name', 'firstname', 'given name', 'forename']
  },
  {
    key: 'lastName',
    label: 'Last Name',
    category: 'Contact',
    identityRelevant: true,
    requiredForIdentity: false,
    allowMultipleSources: false,
    deferred: false,
    synonyms: ['last name', 'lastname', 'surname', 'family name']
  },
  {
    key: 'fullName',
    label: 'Full Name',
    category: 'Contact',
    identityRelevant: true,
    requiredForIdentity: true,
    allowMultipleSources: false,
    deferred: false,
    synonyms: ['full name', 'name', 'contact name', 'person name']
  },
  {
    key: 'workEmail',
    label: 'Work Email',
    category: 'Contact',
    identityRelevant: true,
    requiredForIdentity: true,
    allowMultipleSources: false,
    deferred: false,
    synonyms: ['email', 'work email', 'business email', 'email address', 'primary email']
  },
  {
    key: 'personalEmail',
    label: 'Personal Email',
    category: 'Contact',
    identityRelevant: false,
    requiredForIdentity: false,
    allowMultipleSources: false,
    deferred: false,
    synonyms: ['personal email', 'private email', 'home email']
  },
  {
    key: 'phone',
    label: 'Phone',
    category: 'Contact',
    identityRelevant: false,
    requiredForIdentity: false,
    allowMultipleSources: false,
    deferred: false,
    synonyms: ['phone', 'phone number', 'mobile', 'telephone', 'direct phone']
  },
  {
    key: 'linkedinUrl',
    label: 'LinkedIn URL',
    category: 'Contact',
    identityRelevant: true,
    requiredForIdentity: true,
    allowMultipleSources: false,
    deferred: false,
    synonyms: ['linkedin', 'linkedin url', 'linkedin profile', 'profile url']
  },
  {
    key: 'jobTitle',
    label: 'Job Title',
    category: 'Contact',
    identityRelevant: false,
    requiredForIdentity: false,
    allowMultipleSources: false,
    deferred: false,
    synonyms: ['job title', 'title', 'role', 'position']
  },
  {
    key: 'seniority',
    label: 'Seniority',
    category: 'Contact',
    identityRelevant: false,
    requiredForIdentity: false,
    allowMultipleSources: false,
    deferred: false,
    synonyms: ['seniority', 'seniority level', 'level']
  },
  {
    key: 'department',
    label: 'Department / Function',
    category: 'Contact',
    identityRelevant: false,
    requiredForIdentity: false,
    allowMultipleSources: false,
    deferred: false,
    synonyms: ['department', 'function', 'role function', 'team']
  },
  {
    key: 'location',
    label: 'Location',
    category: 'Contact',
    identityRelevant: false,
    requiredForIdentity: false,
    allowMultipleSources: false,
    deferred: false,
    synonyms: ['location', 'city', 'region', 'country', 'geo']
  },
  {
    key: 'companyName',
    label: 'Company Name',
    category: 'Company',
    identityRelevant: true,
    requiredForIdentity: true,
    allowMultipleSources: false,
    deferred: false,
    synonyms: ['company', 'company name', 'organization', 'organisation', 'account name', 'employer']
  },
  {
    key: 'companyDomain',
    label: 'Company Domain',
    category: 'Company',
    identityRelevant: true,
    requiredForIdentity: true,
    allowMultipleSources: false,
    deferred: false,
    synonyms: ['company domain', 'domain', 'website', 'website domain', 'company website']
  },
  {
    key: 'industry',
    label: 'Industry',
    category: 'Company',
    identityRelevant: false,
    requiredForIdentity: false,
    allowMultipleSources: false,
    deferred: false,
    synonyms: ['industry', 'sector']
  },
  {
    key: 'companySize',
    label: 'Company Size',
    category: 'Company',
    identityRelevant: false,
    requiredForIdentity: false,
    allowMultipleSources: false,
    deferred: false,
    synonyms: ['company size', 'employee count', 'employees', 'headcount']
  },
  {
    key: 'tags',
    label: 'Tags',
    category: 'CRM Overlay',
    identityRelevant: false,
    requiredForIdentity: false,
    allowMultipleSources: true,
    deferred: false,
    synonyms: ['tags', 'labels']
  },
  {
    key: 'owner',
    label: 'Owner',
    category: 'CRM Overlay',
    identityRelevant: false,
    requiredForIdentity: false,
    allowMultipleSources: false,
    deferred: false,
    synonyms: ['owner', 'record owner', 'account owner']
  },
  {
    key: 'stage',
    label: 'Stage',
    category: 'CRM Overlay',
    identityRelevant: false,
    requiredForIdentity: false,
    allowMultipleSources: false,
    deferred: false,
    synonyms: ['stage', 'crm stage', 'pipeline stage', 'status']
  },
  {
    key: 'source',
    label: 'Source',
    category: 'CRM Overlay',
    identityRelevant: false,
    requiredForIdentity: false,
    allowMultipleSources: false,
    deferred: false,
    synonyms: ['source', 'lead source', 'contact source']
  },
  {
    key: 'notes',
    label: 'Notes',
    category: 'CRM Overlay',
    identityRelevant: false,
    requiredForIdentity: false,
    allowMultipleSources: true,
    deferred: false,
    synonyms: ['notes', 'comments', 'description']
  }
];

export const CANONICAL_IMPORT_FIELD_MAP = CANONICAL_IMPORT_FIELDS.reduce((acc, field) => {
  acc[field.key] = field;
  return acc;
}, {});

export const CANONICAL_IMPORT_GROUPS = ['Contact', 'Company', 'CRM Overlay'];
